import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
//import { AddCategoriesHooks } from "./hooks/CategoriesHooks";
import SearchBar from "../../components/universal/SearchBar";
import AddChurchFields from "../../components/Ministry/MinistryField";
import Navbar from "../../components/universal/Navbar";
import { AllChurchHooks } from "./hooks/Ministryhooks";
function AddChurch({church}) {
  const [loading, setLoading] = useState(true);

const {setReloadData,reloadData}=AllChurchHooks();

  const location = useLocation();
  const { userInfo } = useSelector((state) => state.user);
  const hideUI = location.pathname.includes("addfield") || userInfo?.roleCode==='17dwer8'||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField") ;
  return (
    <div className="App relative bg-[#191919] h-fit min-h-screen w-full overflow-x-hidden flex p-4">
     { !hideUI &&<Navbar />}
      <div className={`min-w-0 flex-1 ${!hideUI &&'md:pl-32'} md:pt-0 pt-20`}>
        <div className="flex min-w-0 flex-col gap-4 h-full">
       { !hideUI &&  <SearchBar
            placeholder={"Search"}
            //value={value}
            //onChangeSearchBar={onChangeSearchBar}
          />
       }
          <div className="MAIN-CONTENT min-w-0 flex-1 flex flex-col h-full gap-4">
            <div className="flex justify-end">
            </div>
            <AddChurchFields data={location?.state} setLoading={setLoading} church={church} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddChurch;
